import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function Size(props: IIcon) {
    const newViewProps = '0 0 32 32' ?? props.viewBox;
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={newViewProps}
            style={props.style}
            className={props.className}
        >
            <g>
                <path d="M32 32.033v-11.645l-3.497 3.497-5.219-5.219-4.638 4.638 5.219 5.219-3.51 3.51h11.645z"></path>
                <path d="M0 32.033h11.645l-3.497-3.497 5.219-5.219-4.638-4.638-5.219 5.219-3.503-3.51-0.007 11.645z"></path>
                <path d="M0 0v11.645l3.497-3.497 5.219 5.219 4.638-4.638-5.219-5.219 3.51-3.51h-11.645z"></path>
                <path d="M32 0.007h-11.645l3.497 3.497-5.219 5.219 4.638 4.638 5.219-5.219 3.51 3.51v-11.645z"></path>
            </g>
        </Icon>
    );
}
